import React from "react";

// Real Borderless logo — icon mark only (4-quadrant symbol) inlined as SVG
// Full wordmark logo is used via /public/borderlessLogo.svg as <img>
const BorderlessLogo = () => (
  <div className="flex items-center justify-center mb-8">
    <img
      src="/borderlessLogo.svg"
      alt="Borderless"
      className="h-9"
    />
  </div>
);

const AuthCard = ({ children }) => (
  <div className="min-h-screen bg-pageBg flex items-center justify-center p-4">
    <div className="w-full max-w-[480px]">
      <BorderlessLogo />
      <div className="bg-cardBg border border-cardBorder rounded-card shadow-cardLg p-8">
        {children}
      </div>
    </div>
  </div>
);

export default AuthCard;
